namespace Matrix.Indexation {
    export interface IndexRorForm {
        IndexationProfileCode: Serenity.StringEditor;
        IndexCode: Serenity.StringEditor;
        BaseDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        SourceCode: Serenity.StringEditor;
        IndexRor: Serenity.DecimalEditor;
        PriceIndex: Serenity.DecimalEditor;
        IndexCurrency: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class IndexRorForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.IndexRor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexRorForm.init)  {
                IndexRorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(IndexRorForm, [
                    'IndexationProfileCode', w0,
                    'IndexCode', w0,
                    'BaseDate', w1,
                    'EffectiveDate', w1,
                    'SourceCode', w0,
                    'IndexRor', w2,
                    'PriceIndex', w2,
                    'IndexCurrency', w0,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
